var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app",attrs:{"data-page":_vm.$route.name}},[_c('v-main',[_c('Header'),_c('router-view',{key:_vm.$route.fullPath,staticClass:"biblioteca"}),_c('Cookies')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }